// extracted by mini-css-extract-plugin
module.exports = {"content":"DefaultLayout_content__Cewq_"};